
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.164 9.313V8.14l3.07-.985 1-3.187-4.07-1.313V1.484L4.54 3.016 5.297.609h.96l-.85 2.711 4.382 1.532v1.093L3.93 7.992l-.554 1.774h-.96l.437-1.391-2.688.938zM8.68 5.397L5.11 4.25l-.805 2.563L8.68 5.397z","fill":"currentColor"}})])
          )
        }
      }
    